import React from 'react'
import { getDateFormat } from '../../Config/functions'

export const EhcBooking = ({date,time}:any) => {
    return (
        <div className="col-sm-6 mt-5">
            <h4>EHC Booking Date Time</h4>
            <table className="table table-striped border-0 mt-4">
                <tbody>
                    <tr>
                        <th scope="row">Booking Date:</th>
                        <td>{date ? getDateFormat(date) : ""}</td>
                    </tr>
                    <tr>
                        <th scope="row">Booking Time (24H Format):</th>
                        <td>{time}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
